import DOMPurify from "dompurify";
import { classNameParkerPrefix as prefixPk } from "@/utils/common";
import "./index.less";

const intersectionObserverConfig = {
  rootMargin: "0px 0px 200px 0px",
};

const createIntersectionObserver = () => {
  return new IntersectionObserver((entries) => {
    entries
      .filter(({ isIntersecting }) => isIntersecting)
      .forEach(({ target }) => {
        const src = target.getAttribute("data-src");
        target.setAttribute("src", src);
      });
  }, intersectionObserverConfig);
};

export default class EditorRender {
  public dom: HTMLElement;

  public htmlString: string;

  public renders: any[];

  public lazyload: boolean;

  private intersectionObserver: IntersectionObserver;

  constructor(dom, { defaultValue = "", renders = [], lazyload = false }) {
    this.dom = dom;
    this.renders = renders;
    this.lazyload = lazyload;
    if (!window.IntersectionObserver) this.lazyload = false;
    this.clearDOM(this.dom);
    this.render(defaultValue);
  }

  setValue = (str: string) => {
    if (str && typeof str === "string") {
      // 临时方案，替换className前缀，后期会修改数据存储格式
      this.htmlString = str;
    } else {
      this.htmlString = "";
    }
  };

  render = async (htmlString?) => {
    this.setValue(htmlString);
    const documentFragment = document.createDocumentFragment();
    const $container = document.createElement("div");
    $container.classList.add(prefixPk("view-container"));
    $container.innerHTML = DOMPurify.sanitize(this.htmlString, {
      ALLOW_UNKNOWN_PROTOCOLS: true,
    });
    for (let i = 0; i < this.renders.length; i++) {
      if (this.renders[i].preprocess) {
        await this.renders[i].preprocess($container, {
          lazyload: this.lazyload,
          containerWidth: this.dom.clientWidth,
        });
      }
    }
    this.renders.forEach((render) => {
      if (render.fragmentCls && render.fragmentRender) {
        Array.from($container.querySelectorAll(render.fragmentCls)).forEach(
          (node) => {
            render.fragmentRender(node, $container);
          }
        );
      }
    });
    this.renders.forEach((render) => {
      if (render.containerRender) {
        render.containerRender($container, {
          lazyload: this.lazyload,
          containerWidth: this.dom.clientWidth,
        });
      }
    });
    documentFragment.appendChild($container);
    this.clearDOM(this.dom);
    this.dom.appendChild(documentFragment);
    if (this.lazyload) {
      this.intersectionObserver = createIntersectionObserver();
      this.initLazyload();
    }
  };

  clearDOM = (dom) => {
    dom.innerHTML = "";
  };

  initLazyload = () => {
    if (this.lazyload) {
      Array.from(this.dom.querySelectorAll("img")).forEach((node) => {
        if (node.getAttribute("data-src")) {
          this.intersectionObserver.observe(node);
        }
      });
    }
  };
}
